/**
 * CLDR/ICU outdated aliases → current IANA primary identifiers.
 * @see https://github.com/tc39/proposal-canonical-tz
 */
export const IANA_PRIMARY_BY_ALIAS = {
  'Asia/Calcutta': 'Asia/Kolkata',
  'Europe/Kiev': 'Europe/Kyiv',
  'Asia/Saigon': 'Asia/Ho_Chi_Minh',
  'Asia/Rangoon': 'Asia/Yangon',
  'Asia/Katmandu': 'Asia/Kathmandu',
  'Africa/Asmera': 'Africa/Asmara',
  'America/Coral_Harbour': 'America/Atikokan',
  'Atlantic/Faeroe': 'Atlantic/Faroe',
  'America/Godthab': 'America/Nuuk',
  'Pacific/Truk': 'Pacific/Chuuk',
  'Pacific/Yap': 'Pacific/Chuuk',
  'Pacific/Enderbury': 'Pacific/Kanton',
  'Pacific/Ponape': 'Pacific/Pohnpei',
  'Asia/Ulan_Bator': 'Asia/Ulaanbaatar',
};

/**
 * Map known CLDR aliases to IANA primary IDs; unknown values pass through.
 * @param {string} tz
 * @returns {string}
 */
export const canonicalizeIanaTimezone = (tz) => {
  if (!tz || typeof tz !== 'string') {
    return tz;
  }
  const trimmed = tz.trim();
  return IANA_PRIMARY_BY_ALIAS[trimmed] || trimmed;
};

/** Device IANA timezone, normalized to primary ID when aliased. */
export const getDeviceTimezone = () =>
  canonicalizeIanaTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
